var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-live",class:!_vm.live ? 'disable' : '',attrs:{"href":_vm.matchCentreUrl}},[_vm._v("LIVE")])])
}
var staticRenderFns = []

export { render, staticRenderFns }